import * as React from 'react';
import { Route, Redirect, RouteProps, useLocation } from 'react-router-dom';

// internal
import {
  getBrand,
  getProject,
  getToken,
  getKeyCallbackRedirectFallback,
  clearKeyCallbackRedirectFallback,
} from '@app/utils/localStorage';

interface IProps extends RouteProps {
  mode?: 'auth' | 'unauth' | 'gateway';
  brand?: boolean;
  project?: boolean;
}

const RoutePrivate: React.FC<IProps> = (props) => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (props.mode === 'auth' && !getToken()) {
    if (getKeyCallbackRedirectFallback()) {
      const pathToRedirect = getKeyCallbackRedirectFallback();
      clearKeyCallbackRedirectFallback();
      // eslint-disable-next-line no-restricted-globals
      location.assign(pathToRedirect);
    }
    return <Redirect to="/account" />;
  } else if (props.mode === 'unauth' && getToken()) {
    return <Redirect to="/" />;
  } else if (props.mode === 'gateway') {
    return <Redirect to="/gateway" />;
  }

  if (props.brand && !getBrand()) {
    return <Redirect to="/brand" />;
  }

  if (props.project && !getProject()) {
    return <Redirect to="/project" />;
  }

  return <Route {...props} />;
};

export default RoutePrivate;
